import {
  FileFolderType,
  FileFolderTypeWithContent,
  FolderRootPath,
} from '~shared/types/api';

export const ROLES_TAB_PATH = 'roles.json';
export const SETTINGS_TAB_PATH = 'qodlyApp.json';
export const MODEL_TAB_PATH = 'model.4DModel';
export const HTTP_HANDLERS_PATH = 'HTTPHandlers.json';
export const LOCALIZATION_PATH = 'Localization/i18n';

export function getTypeFromExtension(path: string): FileFolderTypeWithContent {
  const chunks = path.split('.');
  const ext = chunks.pop() as string;
  const root = chunks.join('.').split('/')[0];

  switch (true) {
    case ext === '4DModel':
      return FileFolderType.MODEL;
    case ext === 'WebForm':
      return FileFolderType.WEBFORM;
    case ['4dm', '4qs', '4qm'].includes(ext) && root === FolderRootPath.METHODS:
      return FileFolderType.METHOD;
    case ['4dm', '4qs', '4qm'].includes(ext) && root === FolderRootPath.CLASSES:
      return FileFolderType.CLASS;
    case path === ROLES_TAB_PATH:
      return FileFolderType.ROLES;
    case path === HTTP_HANDLERS_PATH:
      return FileFolderType.HTTP_HANDLERS;
    case path === SETTINGS_TAB_PATH:
      return FileFolderType.SETTINGS;
    default:
      return FileFolderType.TEXT;
  }
}

export function getFileExtentionFromType(type: string, qodly = false) {
  // const { qodly } = store.getState().settings.app;
  // const qodly = true;
  switch (type) {
    case FolderRootPath.REPORTS:
    case 'report':
      return 'QoDoc';
    case FolderRootPath.WEBFORMS:
    case 'webform':
      return 'WebForm';
    case 'Mobile':
    case 'mform':
      return 'MForm';
    case 'class':
    case 'method':
    case FolderRootPath.CLASSES:
    case FolderRootPath.METHODS: {
      return qodly ? '4qs' : '4dm';
    }
    default:
      return '';
  }
}

export function extractWebformName(path: string, fallbackName: string = '') {
  const match = /(?<=\/)(\w+)(?=\.)/.exec(path);
  return match ? match[1] : fallbackName;
}
